import { baseApiUrl } from '@fund-base/constants/general/general.constants';

export const aiAssistantChatApiUrl = `${baseApiUrl}/ai/assistant-chat`;
export const aiVisitorAssistantChatApiUrl = `${baseApiUrl}/ai/visitor/assistant-chat`;
export const aiExtractApiUrl = `${baseApiUrl}/ai/extract`;
export const aiVisitorExtractApiUrl = `${baseApiUrl}/ai/visitor/extract`;
export const aiOnboardingChatApiUrl = `${baseApiUrl}/ai/onboarding-chat`;
export const aiOnboardingConfirmApiUrl = `${baseApiUrl}/ai/onboarding-chat/confirm`;

export const AI_ASSISTANT_WELCOME_MESSAGE =
  "Hi! I'm the Atlas Virtual Assistant. Tell me about your project and I'll find the best funding sources for you.";

/** Once set per user, the onboarding AI modal is no longer auto-opened on the overview page. */
export const onboardingAiModalDismissedStorageKeyPrefix = 'onboarding_ai_modal_dismissed';

export function getOnboardingAiModalDismissedStorageKey(userId: number | string): string {
  return `${onboardingAiModalDismissedStorageKeyPrefix}_${userId}`;
}
